import React from "react";
import { NavLink } from "react-router-dom";
import { canAccessRoute } from "../../security/routes";
import "./SettingsTabs.css";

export const settingsTabs = [
  ["Users", "/Main/Members"],
  ["Assets", "/Main/Assets"],
  ["User Groups", "/Main/Usergroups"],
  ["Round Settings", "/Main/Adminsettings"],
  ["Admin Settings", "/Main/Profile"],
];

export function getSettingsPath() {
  return ["/Main/Usergroups", ...settingsTabs.map(([, path]) => path)]
    .find((path) => canAccessRoute(path));
}

export default function SettingsTabs({ className = "membadd" }) {
  return (
    <nav className={`settings-tabs ${className}`} aria-label="System settings">
      {settingsTabs.filter(([, path]) => canAccessRoute(path)).map(([label, path]) => (
        <NavLink key={path} to={path} className="contrilink" activeClassName="settings-tab-active">
          {label}
        </NavLink>
      ))}
    </nav>
  );
}
